// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownTwoToneSvg from "@fishx/icons-svg/es/asn/FileUnknownTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownTwoToneSvg
  }));
};

FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
export default React.forwardRef(FileUnknownTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileUnknownTwoTone.js
// module id = 2760
// module chunks = 0